import baseWs from "./baseWs";
import _ from "lodash";
import moment from "moment";
//import axios from 'axios';

export function fetchGenericData(searchInput) {
  return baseWs
    .post("/api/services/app/genericScreen/FetchData", {
      screenId: searchInput.screenId,
      aggregateOptions: searchInput.aggregateOptions,
      panelId: searchInput.panelId,
      queryOptions: searchInput.queryOptions,
      schema: searchInput.schema,
      searchSize: searchInput.searchSize,
      tableName: searchInput.tableName,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (!_.isEmpty(err.response)) {
        console.log("Error");
      }
      console.log("Error getting generic data: " + err);
      throw err;
    });
}

// These web services are used for the search panels
export function fetchQueries(screenId, panelId) {
  return baseWs
    .post("/api/services/app/genericScreen/FetchQueries", {
      screenId: screenId,
      panelId: panelId,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (!_.isEmpty(err.response)) {
        console.log("Error");
      }
      console.log("Error getting screen info: " + err);
      throw err;
    });
}

export function saveQuery(query) {
  return baseWs
    .post("/api/services/app/genericScreen/SaveQuery", {
      screenId: query.screenId,
      panelId: query.panelId,
      queryName: query.queryName,
      // schema: query.schema,
      // tableName: query.tableName,
      // queryOptions: query.queryOptions,
      // aggregateOptions: query.aggregateOptions
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (!_.isEmpty(err.response)) {
        console.log("Error");
      }
      console.log("Error getting screen info: " + err);
      throw err;
    });
}

export function deleteQuery(screenId, panelId) {
  return baseWs
    .post("/api/services/app/genericScreen/DeleteQuery", {
      screenId: screenId,
      panelId: panelId,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (!_.isEmpty(err.response)) {
        console.log("Error");
      }
      console.log("Error getting screen info: " + err);
      throw err;
    });
}

// These web services are used for the overviewdatagrid panels and the detail panels
export function insertRecord(record, screenId, panelId) {
  return baseWs
    .post("/api/services/app/genericScreen/insertRecord", {
      data: record,
      screenId: screenId,
      panelId: panelId,
      timezone: new Date().getTimezoneOffset(),
      // Note: Unlike moment.fn.zone this function returns the real offset from UTC,
      // not the reverse offset (as returned by Date.prototype.getTimezoneOffset).
      // timeZone: moment().utcOffset(),
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (!_.isEmpty(err.response)) {
        console.log("Error");
      }
      console.log("Error inserting record: " + err);
      throw err;
    });
}

export function updateRecord(record, screenId, panelId) {
  return baseWs
    .post("/api/services/app/genericScreen/updateRecord", {
      data: record,
      id: record.id,
      screenId: screenId,
      panelId: panelId,
      timezone: new Date().getTimezoneOffset(),
      // Note: Unlike moment.fn.zone this function returns the real offset from UTC,
      // not the reverse offset (as returned by Date.prototype.getTimezoneOffset).
      // timeZone: moment().utcOffset(),
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (!_.isEmpty(err.response)) {
        console.log("Error");
      }
      console.log("Error updating record with id " + record.id + ": " + err);
      throw err;
    });
}

export function deleteRecord(record, screenId, panelId) {
  return baseWs
    .post("/api/services/app/genericScreen/deleteRecord", {
      id: record.id,
      screenId: screenId,
      panelId: panelId,
      timezone: new Date().getTimezoneOffset(),
      // Note: Unlike moment.fn.zone this function returns the real offset from UTC,
      // not the reverse offset (as returned by Date.prototype.getTimezoneOffset).
      // timeZone: moment().utcOffset(),
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (!_.isEmpty(err.response)) {
        console.log("Error");
      }
      console.log("Error deleting record with id " + record.id + ": " + err);
      throw err;
    });
}
